// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"48d65b47","561":"f5aa2d7f","598":"b037751d","779":"8109259e"}[chunkId] + ".chunk.js";
};